module.exports = __webpack_public_path__ + "media/images/desktop_new_logo-7a4617c46c4c2663a111dba71ad7f8d0.svg";